<template>
    <div class="wrapper">
        <div class="container">
            <div class="right-column" :class="{ 'hovered': isHoverRight }" @mouseover="isHoverRight = true">
                <h2>Personal Center</h2>
                <div class="avatar" style="text-align: center;">
                    <el-upload class="avatar-uploader" action="https://www.qihang.store/sb/file/upload" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="uploadDisabled">
                        <img v-if="userData.avatar" :src="userData.avatar" class="avatar"
                            style="border-radius: 50%; width: 100px; height: 100px;">
                        <img v-else class="el-icon-plus avatar-uploader-icon" src="../images/user.png"
                            style="border-radius: 50%; width: 100px; height: 100px;">
                    </el-upload>
                </div>
                <el-form :model="userData" ref="userInfoForm" label-width="100px" v-if="!showChangePassword">
                    <el-form-item label="username" prop="userName">
                        <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-user"
                            v-model="userData.userName"></el-input>
                    </el-form-item>
                    <el-form-item label="nation" prop="country">
                        <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-location"
                            v-model="userData.country" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="City" prop="city">
                        <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-location"
                            v-model="userData.city" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="create time">
                        <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-time"
                            v-model="userData.lastLoginTime" disabled></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="medium" @click="saveUserInfo">save</el-button>
                        <el-button type="primary" size="medium" @click="showChangePasswordForm">change Password</el-button>
                    </el-form-item>
                </el-form>
                <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordForm"
                    v-show="showChangePassword" label-position="left" label-width="100px">
                    <el-form-item label="Old Pass." prop="oldPassword">
                        <el-input size="medium" prefix-icon="el-icon-lock" v-model="changePasswordForm.oldPassword"
                            show-password></el-input>
                    </el-form-item>
                    <el-form-item label="New Pass." prop="newPassword">
                        <el-input size="medium" prefix-icon="el-icon-lock" v-model="changePasswordForm.newPassword"
                            show-password></el-input>
                    </el-form-item>
                    <el-form-item label="Conf. Pass." prop="confirmPassword">
                        <el-input size="medium" prefix-icon="el-icon-lock" v-model="changePasswordForm.confirmPassword"
                            show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="medium" @click="changePassword()">Confirm the changes</el-button>
                        <el-button type="danger" size="medium" @click="cancelChangePassword">Cancel</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request';
import md5 from 'js-md5'
export default {
    data() {
        return {
            uploadDisabled: false,
            breadcrumb_teb: {},
            imageUrl: '',
            isHoverRight: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            showChangePassword: false,
            changePasswordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            changePasswordRules: {
                oldPassword: [
                    { required: true, message: 'Please enter old password', trigger: 'blur' },
                    { min: 6, max: 20, message: '8 to 20 characters in length', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: 'Please enter a new password', trigger: 'blur' },
                    { min: 6, max: 20, message: '8 to 20 characters in length', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: 'Please confirm new password', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.changePasswordForm.newPassword) {
                                callback(new Error('The passwords entered twice are inconsistent'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        saveUserInfo() {
            request.post("/users/save", this.userData).then(res => {
                if (res.code === "USERNAME_REPEAT") {
                    this.$message.error("The username is duplicated, please re-enter it.")
                } else if (res.code === "SERVER_ERROR") {
                    this.$message.error("system error")
                } else if (res.code === "SUCCESS") {
                    let userData = JSON.parse(localStorage.getItem("userData"))
                    userData.userName = this.userData.userName;
                    userData.avatar = this.userData.avatar;
                    localStorage.setItem("userData", JSON.stringify(userData));
                    this.$store.state.teb.avatar = this.userData.avatar
                    this.$store.state.teb.isavatar = true
                    this.$message.success("Saved successfully")
                    this.$router.push('/home');
                    console.log(this.$store.state.teb.avatar)
                } else if (res.code === 'TOKEN_VERIFY_ERROR') {
                    this.$message.error("The TOKEN value has expired, please log in again.")
                }
                console.log(res)
            })
        },
        handleAvatarSuccess(res, file) {
            this.userData.avatar = res;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === "image/jpg";

            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('Upload avatar images can only be in JPG or PNG format!');
            }
            if (!isLt2M) {
                this.$message.error('The size of the uploaded avatar image cannot exceed 5MB!');
            }
            return isJPG && isLt2M;
        },
        showChangePasswordForm() {
            this.showChangePassword = true;
            this.uploadDisabled = true  //禁止点击
        },
        cancelChangePassword() {
            this.showChangePassword = false;
            this.uploadDisabled = false
            // 清空修改密码表单数据
            this.changePasswordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            };
        },
        changePassword(changePasswordForm) {
            this.$refs.changePasswordForm.validate((valid) => {
                if (valid) {
                    request.get("/users/changePassword", {
                        params: {
                            userName: this.userData.userName,
                            oldPassword: md5(this.changePasswordForm.oldPassword),
                            newPassword: md5(this.changePasswordForm.newPassword),
                        }
                    }).then(res => {
                        console.log("修改密码", res)
                        if (res.code === "USERPASSWORD_ERROR") {
                            this.$message.error("The old password was entered incorrectly, please re-enter it.")
                            this.changePasswordForm = {
                                oldPassword: '',
                                newPassword: '',
                                confirmPassword: ''
                            };
                        } else if (res.code === "SUCCESS") {
                            this.$message.success("Successfully modified")
                            localStorage.removeItem("userData");
                            this.$router.push('/login')
                        }
                    })
                } else {
                    return false;
                }
            });
        }
    },
    created() {
        this.breadcrumb_teb.name = 'Personal Center'
        this.breadcrumb_teb.model = 'center'
        this.breadcrumb_teb.path = '/center'
        this.$store.commit('clearTabsListExceptFirst')
        this.$store.commit('updateSecondTab', this.breadcrumb_teb)
    }
};
</script>

<style scoped>
.wrapper {
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
}

.right-column {
    flex: 1;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    transform-origin: center center;
}

.right-column.hovered {
    transform: perspective(1000px) scale(1.2) rotateY(0deg);
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.el-input {
    margin-bottom: 10px;
}

.el-button {
    margin-top: 10px;
}

.avatar {
    text-align: center;
    margin-bottom: 20px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    /* 居中 */
    margin-bottom: 2%;
}

.change-password-form {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    background-color: #f5f7fa;
}

.form-item {
    margin-bottom: 20px;
}

.password-hint {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
    display: block;
}

.button-group {
    text-align: right;
}
</style>